import "../../../FhButton.css";
import { useSlots, computed, onMounted, openBlock, createBlock, mergeProps, withCtx, createCommentVNode, renderSlot } from "vue";
import FhButtonBase from "../FhButtonBase/FhButtonBase.mjs";
import FhIcon from "../../FhIcon/FhIcon.mjs";
import dropdown from "../../../icons/dropdown.mjs";
import externalLink from "../../../icons/externalLink.mjs";
import { VARIANTS_ENUMS, SIZES_ENUMS, VARIANT_ICON_COLOR_MAP } from "../constants.mjs";
import { isExternalURL } from "../../../utils/url.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhButton",
  props: {
    variant: {
      type: String,
      default: VARIANTS_ENUMS.PRIMARY,
      validator: (value) => Object.values(VARIANTS_ENUMS).includes(value)
    },
    size: {
      type: String,
      default: SIZES_ENUMS.MD,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ""
    },
    dropdown: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: "",
      validator: (value) => value === "" || value.startsWith("<svg") && value.endsWith("</svg>")
    }
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const suffixIcon = computed(() => {
      if (props.dropdown) {
        return dropdown;
      }
      if (isExternalURL(props.href)) {
        return externalLink;
      }
      return null;
    });
    const computedButtonClasses = computed(() => {
      return [
        `fh-button--${props.size}`,
        props.fullWidth && "fh-button--full-width",
        props.dropdown && "fh-button--dropdown",
        isExternalURL(props.href) && "fh-link--external"
      ];
    });
    const computedIconSize = computed(() => {
      return props.size === SIZES_ENUMS.XS || props.size === SIZES_ENUMS.SM || props.size === SIZES_ENUMS.MD ? "sm" : "md";
    });
    const computedIconColor = computed(() => {
      if (props.disabled) {
        return "disabled";
      }
      if (props.selected) {
        return "primary-default";
      }
      return VARIANT_ICON_COLOR_MAP[props.variant];
    });
    onMounted(() => {
      if (!slots.default || slots.default().length === 0) {
        console.warn("FhButton component requires default slot content.");
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhButtonBase, mergeProps({
        href: props.href,
        disabled: props.disabled,
        selected: props.selected,
        loading: props.loading,
        variant: props.variant,
        class: computedButtonClasses.value
      }, _ctx.$attrs), {
        default: withCtx(() => [
          props.icon ? (openBlock(), createBlock(FhIcon, {
            key: 0,
            size: computedIconSize.value,
            icon: props.icon,
            color: computedIconColor.value
          }, null, 8, ["size", "icon", "color"])) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "default", {}, void 0, true),
          suffixIcon.value ? (openBlock(), createBlock(FhIcon, {
            key: 1,
            class: "fh-button-suffix--dropdown",
            size: computedIconSize.value,
            icon: suffixIcon.value,
            color: computedIconColor.value
          }, null, 8, ["size", "icon", "color"])) : createCommentVNode("", true)
        ]),
        _: 3
      }, 16, ["href", "disabled", "selected", "loading", "variant", "class"]);
    };
  }
});
const FhButton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-3cb1b367"]]);
export {
  FhButton as default
};
//# sourceMappingURL=FhButton.mjs.map
